import React from 'react';
import {observer} from 'mobx-react'
import BaseBindedComponent, { BaseBindedComponentProps, BaseBindedComponentState } from '../base-components/BaseBindedComponent'
import ComponentOuterDiv from "./ComponentOuterDiv";
import { IDomainData, IUICheckboxColDef, IUICheckboxDef } from '../../datatypes';
import { toBoolean } from '../../utils/config-utils';

const {MDBInput} = require('mdbreact');

interface CheckboxProps extends BaseBindedComponentProps{
    metadata:IUICheckboxColDef|IUICheckboxDef;
}
class Checkbox extends BaseBindedComponent<CheckboxProps, BaseBindedComponentState> {
    // TODO: why not use state???
    private id:string = '';
    private readonly = false;
    
    // why skip ctor for Checkbox ???
    // constructor(props: CheckboxProps & {[key:string]:IDomainData}){
    //     super(props);
    // }
  /*
  Setting tabIndex to MDB label in DOM (as MDBComponent doesnt accept tabIndex by default)
  Making sure the tabIndex is 0 only when it is not readonly.
   */
  setInputAttributes = ()=>{
    let inputElem = this.id && !this.readonly ? document.querySelector(`#${this.id}.form-check-label`) : null;
    if(inputElem){
      inputElem.setAttribute('tabindex', '0');
    }
  }

  componentDidMount(){
    this.setInputAttributes();
  }

  componentDidUpdate(){
    this.setInputAttributes();
  }

  render() {
    const props = this.props as CheckboxProps & {[key:string]:IDomainData};

    const {
      properties,
      label,
      disabled,
      readonly,
      cssClasses,
      componentId,
    } = this.props.metadata;

    let width:string|undefined;
    switch(this.props.metadata.type){
        case 'Checkbox': width = undefined; break;
        case 'CheckboxCol': width = this.props.metadata.width;
    }

    let {xs, sm, md, lg} = properties || {};
    const domainAttribute = this.props.domainAttribute!;
    let value = props[domainAttribute.objectName][domainAttribute.name] as string;
    let readonlyClass = readonly ? ' ui-checkbox-readonly' : ''
    let disabledClass = disabled ? ' ui-checkbox-disabled' : ''
    let className = 'ui-renderer-checkbox '+ ((cssClasses ? cssClasses : '') + disabledClass + readonlyClass);
    let hasError = !!this.props.error;
    className += hasError ? ' is-invalid ' : '';
    let id = domainAttribute.namePrefix + componentId
    id = (id.charAt(0).toLowerCase() + id.slice(1)).replace(/\./g, "-");
    id = id.replace(/[\[\]]/g, "_")
    this.id = id;
    this.readonly = readonly;

    let domainDataType = domainAttribute.domainDataType;
    let valueForChecked = domainDataType === 'Number' || domainDataType === 'Boolean' ? 1 : 'Y';
    let valueForNotChecked = domainDataType === 'Number' || domainDataType === 'Boolean' ? 0 : 'N';
    let calculatedLabel = this.props.dataGridField ? ' ' : label;

    return (
        <ComponentOuterDiv width={width} dataGridField={!!this.props.dataGridField} xs={xs} sm={sm} md={md} lg={lg}>
          <div className={"ui-renderer-checkbox-outer-div"}>
          <MDBInput
              containerClass = {className}
              type='checkbox'
              filled
              disabled={disabled}
              readOnly={readonly}
              error={this.props.error}
              id={id}
              label={calculatedLabel}
              checked={toBoolean(value)}
              onChange={(e: { target: { checked: boolean; }; })=>this.onChangeHandler(e.target.checked === true ? valueForChecked : valueForNotChecked , true)}
          />
          <div className={"invalid-feedback"} style={{display: hasError ? 'block': 'none'}}>{this.props.error}</div>
          </div>
        </ComponentOuterDiv>
    )
  }
}

export default observer (Checkbox);